import { CompanyDetailFormModel } from '../../models/company-form.model';
import { CompanyNetsuiteDetail } from '../../models/company.model';

type NetsuiteFormFields = Pick<
  CompanyDetailFormModel,
  | 'netsuiteEnabled'
  | 'netsuiteInternalId'
  | 'netsuiteCompanyName'
  | 'netsuitePrimaryEmail'
  | 'netsuiteBillingAddress'
  | 'netsuiteBillingCity'
  | 'netsuiteBillingState'
  | 'netsuiteBillingZip'
  | 'netsuiteBillingCountry'
>;

export class CompanyNetsuiteFormMapper {
  public fromNetsuiteDetail(
    netsuite: CompanyNetsuiteDetail,
  ): NetsuiteFormFields {
    return {
      netsuiteEnabled: netsuite.enabled,
      netsuiteInternalId: netsuite.internalId,
      netsuiteCompanyName: netsuite.companyName,
      netsuitePrimaryEmail: netsuite.primaryEmail,
      netsuiteBillingAddress: netsuite.billingAddress,
      netsuiteBillingCity: netsuite.billingCity,
      netsuiteBillingState: netsuite.billingState,
      netsuiteBillingZip: netsuite.billingZip,
      netsuiteBillingCountry: netsuite.billingCountry,
    };
  }

  public toNetsuiteDetail(
    model: CompanyDetailFormModel,
  ): CompanyNetsuiteDetail | undefined {
    if (!model.netsuiteEnabled) return undefined;
    return {
      enabled: true,
      internalId: model.netsuiteInternalId,
      companyName: model.netsuiteCompanyName,
      primaryEmail: model.netsuitePrimaryEmail,
      billingAddress: model.netsuiteBillingAddress,
      billingCity: model.netsuiteBillingCity,
      billingState: model.netsuiteBillingState,
      billingZip: model.netsuiteBillingZip,
      billingCountry: model.netsuiteBillingCountry,
    };
  }
}
